const ukviat_account = {
  init() {    
    var forgotPassword = document.querySelector('.js-forgot-password');
    var forgotPasswordBox = document.querySelector('.js-forgot-password-box');
    var login = document.querySelector('.js-login');
    var loginBox = document.querySelector('.js-login-box');
    
    if(loginBox) {
      forgotPassword.addEventListener('click', (event) => {
        forgotPasswordBox.style.display = 'block';
        loginBox.style.display = 'none';
        event.preventDefault();
      });

      login.addEventListener('click', (event) => {
        forgotPasswordBox.style.display = 'none';
        loginBox.style.display = 'block';
        event.preventDefault();
      });
    }
  },

  addresses() {
    var addAddress = document.querySelector('.js-add-new-address');
    var currentAddresses = document.querySelector('.c-current-addresses');
    var newAddress = document.querySelector('.js-new-address');
    var cancelAddingNewAddress = document.querySelector('.js-cancel-add-new-address');
    var deleteAddress = document.querySelectorAll('.js-address-delete');
    var editAddress = document.querySelectorAll('.js-address-edit');
    var editAddressForm = document.querySelectorAll('.js-edit-address');
    var cancelSaveAddress = document.querySelectorAll('.js-cancel-save-address');

    if(addAddress) {
      addAddress.addEventListener('click', (event) => {
        currentAddresses.style.display = 'none';
        newAddress.style.display = 'block';
        event.preventDefault();
      });
    }

    if(cancelAddingNewAddress) {
      cancelAddingNewAddress.addEventListener('click', (event) => {
        currentAddresses.style.display = 'block';
        newAddress.style.display = 'none';
        event.preventDefault();        
      });
    }

    if(deleteAddress) {
      deleteAddress.forEach((el, index) => {
        el.addEventListener('click', (event) => {
          Shopify.CustomerAddress.destroy(el.getAttribute('data-address-id'));
          return false;
        });
      });
    }

    if(editAddress) {
      editAddress.forEach((el, index) => {
        el.addEventListener('click', (event) => {
          currentAddresses.style.display = 'none';
          newAddress.style.display = 'none';
          [].forEach.call(editAddressForm, function(el2) {
            el2.style.display = 'none';
          });
          editAddressForm[index].style.display = 'block';
          return false;
        });
      });
    }
    
    if(cancelSaveAddress) {
      cancelSaveAddress.forEach((el, index) => {
        el.addEventListener('click', (event) => {
          currentAddresses.style.display = 'block';
          [].forEach.call(editAddressForm, function(el2) {
            el2.style.display = 'none';
          });
          return false;
        })
      });
    }
  }
};

ukviat_account.init();
ukviat_account.addresses();

Shopify.CustomerAddress = {
  destroy: function(id, confirm_msg) {
    if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
      Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
    }
  }
}